<!-- 添加审核人员 -->
<template>
    <div>
        <span style="color: red"> 后端需要做 名称,电话号码的 模糊查询</span><br />
        <div class="form-group">
            <el-form :inline="true" :model="checkerSelectMenuForm">
                <el-form-item label="">
                    <el-input v-model="checkerSelectMenuForm.nickName" placeholder="用户名" clearable />
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="checkerSelectMenuForm.phone" placeholder="手机号" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getUserList()">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 展示 -->
            <el-table :data="userList" height="550" style="width: 100%">
                <!-- 用户名 -->
                <el-table-column label="编号" min-width="60px">
                    <template #default="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <!-- 用户名 -->
                <el-table-column label="用户名" min-width="120px">
                    <template #default="scope">
                        {{ scope.row.nickName }}
                    </template>
                </el-table-column>
                <!-- 手机号 -->
                <el-table-column label="手机号" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.phone }}
                    </template>
                </el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" header-align="center" align="center">
                    <template v-slot="scope">
                        <el-button type="warning" @click="selectuser(scope.row)"> 选择 </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="addusepagnation" style="display: flex; align-items: center; justify-content: center">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="color: black"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="itemsPerPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="allitems">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        name: "checkeraddView",
        data() {
            return {
                wwe: "",
                userAllURL: "/api/user/queryAllUser",
                // 筛选条件
                checkerSelectMenuForm: {},

                // 用户列表
                userList: [],

                // 分页器
                currentPage: 1,
                itemsPerPage: 15,
                allitems: 0,
            };
        },
        methods: {
            // 改变条数
            handleSizeChange(val) {
                this.itemsPerPage = val;
                this.getUserList();
            },
            //改变页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getUserList();
            },
            // 获取用户列表
            getUserList() {
                axios
                    .get(this.userAllURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            ...this.checkerSelectMenuForm,
                        },
                    })
                    .then((res) => {
                        this.allitems = res.data.data.total;
                        this.userList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 选中
            selectuser(row) {
                this.$emit("listenuseradd", { loginId: row.idString, nickName: row.nickName, ratio: 1 });
            },
        },
        created() {
            this.nickName = localStorage.getItem("nickname") || "";
            this.phone = localStorage.getItem("tel") || "";
            this.getUserList();
        },
    };
</script>
<style lang="scss" scoped>
    :deep(.addusepagnation > .el-pagination > .is-first) {
        color: #000000 !important;
    }

    :deep(.el-pagination__goto) {
        color: #000000 !important;
    }

    :deep(.el-pagination__classifier) {
        color: #000000 !important;
    }
</style>
